// extracted by mini-css-extract-plugin
module.exports = {"coll":"Coll_coll__1LFwb","branchesLeft":"Coll_branchesLeft__YxW6s","branchesRight":"Coll_branchesRight__2zdss"};